import _ from "lodash";
import { type InputHTMLAttributes, type ReactNode, useEffect, useRef } from "react";

export const AnimatedHeight = (
  props: { children?: ReactNode } & InputHTMLAttributes<HTMLDivElement>
) => {
  const el = useRef<HTMLDivElement>(null);
  const interval = useRef<NodeJS.Timeout | null>(null);

  const updateSize = () => {
    if (el.current) {
      const contentHeight = el.current.scrollHeight;
      const parent = el.current.parentNode as HTMLDivElement;
      parent.style.height = `${contentHeight}px`;
      parent.style.overflow = `hidden`;
    }
  };
  const stopInterval = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };
  useEffect(() => {
    if (!interval.current) return;
    interval.current = setInterval(() => updateSize(), 200);
    return () => stopInterval();
  }, []);

  return (
    <div className="transition-all">
      <div
        {..._.omit(props, "children")}
        ref={el}
        style={{
          boxSizing: "border-box"
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
